import { atom } from 'recoil';
import { shownProductsPerPage } from '../../../appconfig';

export const productPaginationState = atom<number>({
  key: 'productPaginationState',
  default: shownProductsPerPage,
});
